import { z } from "zod";
export const CommunityMilestoneFeedItem = z.object({
    id: z.string().uuid(),
    type: z.literal("milestone"),
    kind: z.string(),
    title: z.string(),
    body: z.string().nullable(),
    createdAt: z.string(),
    publishedAt: z.string().nullable(),
});
//# sourceMappingURL=milestone.js.map